import { useCallback, useRef, useState } from 'react';

// The ref rejects a second call made before React commits `isInFlight`.
export default function useSingleFlight() {
  const isInFlightRef = useRef(false);
  const [isInFlight, setIsInFlight] = useState(false);

  const runSingleFlight = useCallback(async <TResult>(task: () => Promise<TResult>) => {
    if (isInFlightRef.current) return undefined;
    isInFlightRef.current = true;

    setIsInFlight(true);
    try {
      return await task();
    } finally {
      isInFlightRef.current = false;
      setIsInFlight(false);
    }
  }, []);

  return { isInFlight, runSingleFlight };
}
